<cp-daimler-splash *ngIf="!error"></cp-daimler-splash>
<div *ngIf="error" [innerHTML]="error.errorMessage"></div>
<cp-signup-footer-controls *ngIf="!error" [showBackButton]="false" (nextClicked)="nextClicked()"></cp-signup-footer-controls>
